// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kx-0";